import type { UserRole } from '@/entities/admin-user.entity';
import { cn } from '@/lib/utils';

const ROLE_LABEL: Record<UserRole, string> = {
	regwait: 'Ожидание',
	worker: 'Worker',
	carder: 'Carder',
	partner: 'Partner',
	admin: 'Admin',
};

const ROLE_CLASS: Record<UserRole, string> = {
	regwait: 'bg-muted text-muted-foreground',
	worker: 'bg-chart-2/15 text-chart-2',
	carder: 'bg-[#ad46ff]/15 text-[#ad46ff]',
	partner: 'bg-amber-500/15 text-amber-600',
	admin: 'bg-chart-5/15 text-chart-5',
};

interface RoleBadgeProps {
	role: UserRole;
	className?: string;
}

export default function RoleBadge({ role, className }: RoleBadgeProps) {
	return (
		<span className={cn('inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium', ROLE_CLASS[role], className)}>
			{ROLE_LABEL[role]}
		</span>
	);
}
